import React from "react";
import { ComputerImageIcon, Content } from "./error404Elements";
import errorIcon from "assets/404.png";

const Error404 = () => {
  return (
    <Content>
      <ComputerImageIcon src={errorIcon} />
    </Content>
  );
};

export default Error404;
